import { createContext, useContext } from 'react'
import type { V2ProductRegulationSectionContextValue } from './types'

export const V2ProductRegulationSectionContext =
  createContext<V2ProductRegulationSectionContextValue | null>(null)

export function useV2ProductRegulationSection() {
  const context = useContext(V2ProductRegulationSectionContext)
  if (context == null) {
    throw new Error(
      'useV2ProductRegulationSection must be used within V2ProductRegulationSection'
    )
  }
  return context
}
